import styled from "styled-components";
import { rawColors } from "../../design-system/tokens/colors";
import { spacing } from "../../design-system/tokens/spacing";
import { typographyMixin } from "../../design-system/tokens/typography";

/** Full-height placeholder shown while tenant/workspace context resolves. */
export const GuardStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${spacing[6]};
  text-align: center;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const GuardError = styled(GuardStatus)`
  color: ${rawColors.accent.red500};
`;
